import { types } from './types';
import firebase from '../firebase/firebase';

const db = firebase.database();

export const updateLocation = (location) => {
    
    return {
        type: types.UPDATE_LOCATION,
        payload: location
    }
}




// WEBPACK FOOTER //
// ./src/js/actions/router-actions.js